import { createAction } from '@reduxjs/toolkit';
import { RequestError, Callback, MessageMask } from 'types';
import { State } from './types';

export const fetchMessagesMasks = createAction('messages-masks/fetch', (callback?: Callback<unknown, void>) => ({
  payload: undefined,
  meta: { callback },
}));

export const fetchedMessagesMasks = createAction(
  'messages-masks/fetched',
  (data?: State['data'], error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export const fetchMessageMask = createAction(
  'message-mask/fetch',
  (situationId: string, callback?: Callback<unknown, void>) => ({
    payload: undefined,
    meta: { situationId, callback },
  })
);

export const fetchedMessageMask = createAction(
  'message-mask/fetched',
  (data?: State['selectedMessageMask'], error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export const updateMessageMask = createAction(
  'message-mask/update',
  (messageMask: MessageMask, callback?: Callback<unknown, void>) => ({
    payload: undefined,
    meta: { messageMask, callback },
  })
);

export const updatedMessageMask = createAction('message-mask/updated', (data?: MessageMask, error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export const fetchSituationsByClientType = createAction(
  'situationsByClientType/fetch',
  // situationCategoryId is optional
  ({ clientTypeId, situationCategoryId }: { clientTypeId: number; situationCategoryId?: number }) => ({
    payload: { clientTypeId, situationCategoryId },
  })
);

export const fetchedSituationsByClientType = createAction(
  'situationsByClientType/fetched',
  (data?: State['situationsByClientType']['data'], error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export default {
  fetchMessagesMasks,
  fetchedMessagesMasks,
  fetchMessageMask,
  fetchedMessageMask,
  updateMessageMask,
  updatedMessageMask,
  fetchSituationsByClientType,
  fetchedSituationsByClientType,
};
